module.exports = __webpack_public_path__ + "img/web3.a6ed8684.png";